export default __webpack_public_path__ + "static/media/img_klinik_pengetahuan.7fbbf9a9.webp";